import luSaasSearch from "./search";
luSaasSearch.install = function(Vue) {
  Vue.component(luSaasSearch.name, luSaasSearch);
};

export default luSaasSearch;
